/* eslint-disable */
import React, { Component } from 'react';

import Aux from '../../../hoc/Aux';


class ConfigurationScreenHeader extends Component {
  render() {
    return (
      <Aux>
        <br/>
        <br/>
        <br/>
        <br/>
      </Aux>
    );
  }
} 

export default ConfigurationScreenHeader;
